import { useState, useCallback } from "react";

export const useSwitchPayoutModal = () => {
  const [payoutModalOpen, setPayoutModalOpen] = useState(false);
  const [quoteModalOpen, setQuoteModalOpen] = useState(false);

  const handlePayoutModalChange = useCallback((open: boolean) => {
    setPayoutModalOpen(open);
  }, []);

  const handleQuoteModalChange = useCallback((open: boolean) => {
    setQuoteModalOpen(open);
  }, []);

  const handlePayoutRequest = useCallback(() => {
    setPayoutModalOpen(false);
    setQuoteModalOpen(true);
  }, []);

  return {
    payoutModalOpen,
    quoteModalOpen,
    handlePayoutModalChange,
    handleQuoteModalChange,
    handlePayoutRequest,
  };
};
